import React, { useState, useEffect } from 'react';
// import { ForwardMail } from '../Forward';
import MailAttach from '../MailAttach';
import { ReplyMail } from '../Reply';
import { useEmailDetailsStyles } from './EmailDetailsStyles';
import MailBody from './MailBody';
import MailHeader from './MailHeader';
import { ApiEmailService } from '../../../../../config/apiService';

export const MailDetails = ({ email, member, isOwnEmail }) => {
  const rootClasses = useEmailDetailsStyles();

  const [emails, setEmails] = useState([]);

  const getThread = async (start_id, mail_thread_id) => {
    if (mail_thread_id) {
      let data = await ApiEmailService.getEmails('getThreadEmails', [
        `thread=${mail_thread_id}`,
        `start=${start_id}`,
      ]);
      setEmails(data.data);
    } else {
      setEmails([]);
    }
  };
  const getChain = () => {
    return emails.map((current_email, index) => {
      if (!current_email.id) {
        if (!current_email.mail_id) {
          current_email['id'] = 'reply_body_box_' + String(index);
        } else {
          current_email['id'] = current_email.mail_id;
        }
      }
      return (
        <ReplyMail
          key={index}
          email={current_email}
          member={{
            email: current_email.sender_mail,
            first_name: current_email.first_name,
            amera_avatar_url: current_email.profile_url,
            last_name: current_email.last_name,
          }}
        />
      );
    });
  };

  useEffect(() => {
    setEmails([]);
    async function getMails() {
      await getThread(email.mail_id, email.thread_id);
    }
    getMails();
    // eslint-disable-next-line
  }, [email.mail_id]);

  return (
    <div className={rootClasses.detailsWrapper}>
      {email ? (
        <>
          <MailHeader
            email={email}
            member={member}
            isOwnEmail={isOwnEmail}
            senderFirstName={isOwnEmail ? member.first_name : email.first_name}
            senderLastName={isOwnEmail ? member.last_name : email.last_name}
            receiverName={email.receiverName}
            title={`${email.reply && email.reply.id ? 'RE : ' : ''}${
              email.subject
            }`}
            composeTime={email.time}
            senderAvatar={
              isOwnEmail ? member.amera_avatar_url : email.profile_url
            }
            username={
              isOwnEmail
                ? email.first_name
                : `${member.first_name} ${member.last_name}`
            }
          />
          <MailBody body={email.body} id={email.mail_id} />
          <MailAttach attachFiles={email.attachments} />
          {/*{email.reply && email.reply.id && (*/}
          {/*  <ReplyMail email={email.reply} member={member} />*/}
          {/*)}*/}
          {emails && getChain()}
          {/* {email.reply && email.reply.id && (
            <ForwardMail email={email.reply} member={member} />
          )} */}
        </>
      ) : null}
    </div>
  );
};
